import React from 'react';
import NumberFormat from 'react-number-format';

export class ChartRat extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showAll: false
		};

		this.changeShowAll = this.changeShowAll.bind(this);
	}

	changeShowAll() {
		if (this.state.showAll) {
			this.setState({
				showAll: false
			})
		} else {
			this.setState({
				showAll: true
			})
		}
	}

	render() {
		function compare(a, b) {
			if (parseInt(a.res_aktuell_proz) > parseInt(b.res_aktuell_proz) && a.partei_key !== "Sonstige") {
				return -1;
			}
			if (parseInt(a.res_aktuell_proz) < parseInt(b.res_aktuell_proz) || a.partei_key === "Sonstige") {
				return 1;
			}
			return 0;
		}

		let ordered_parteien = [];
		let max = 0.0;
		for (let partei_key in this.props.parteien) {
			if (
					(
						(this.state.showAll && partei_key !== "Sonstige") || 
						(this.state.showAll === false && this.props.parteien[partei_key].sonstige === false)
					) && (
						!('Gemeinden' in this.props.bezirksdaten) || this.props.bezirksdaten.id != 0 || !(partei_key.startsWith('WGR '))
					)
			) {

				if (this.props.bezirksdaten.auszaehlung != 100 || (typeof this.props.bezirksdaten[partei_key + "_Rat_2020_proz"] !== 'undefined'  && this.props.bezirksdaten[partei_key + "_Rat_2020_proz"] !== '')) {
					if (this.props.bezirksdaten[partei_key + "_Rat_2020_proz"] > max) {
						max = this.props.bezirksdaten[partei_key + "_Rat_2020_proz"];
					}
					if (this.props.bezirksdaten[partei_key + "_Rat_2014_proz"] > max && this.props.preview !== true) {
						max = this.props.bezirksdaten[partei_key + "_Rat_2014_proz"];
					}
					ordered_parteien.push({
						"partei_key": partei_key, 
						"res_aktuell_proz": this.props.bezirksdaten[partei_key + "_Rat_2020_proz"],
						"res_aktuell_total": this.props.bezirksdaten[partei_key + "_Rat_2020_total"],
						"res_old_proz": this.props.bezirksdaten[partei_key + "_Rat_2014_proz"],
						"res_old_total": this.props.bezirksdaten[partei_key + "_Rat_2014_total"],
					})
				}
			}
		}

		ordered_parteien = ordered_parteien.sort(compare)
		console.log('ordered_parteien', ordered_parteien)
		return (
			<>
				{this.props.preview !== true && this.props.bezirksdaten.auszaehlung == 100 &&
					<div className="chart-parteien" style={{marginBottom: "10px"}}>
						<div className="bar rounded" style={{"width": "12px", "background": "black", "marginRight": "8px"}}></div>
						<p className="partei" style={{"margin": "0", "minWidth": "unset", "marginRight": "15px"}}>2020</p>
						<div className="bar rounded" style={{"width": "12px", "background": "#b4b4b4", "marginRight": "8px"}}></div>
						<p className="partei" style={{"margin": "0", "color": "#b4b4b4"}}>2014</p>
					</div>
				}
				{this.props.showAbsolute && this.props.bezirksdaten.auszaehlung == 100 &&
					<div className="chart-parteien-group">
						<div className="chart-parteien">
							<div className="w100"></div>
							<div className="chart-parteien-percentage">
								<p>Stimmen</p>
							</div>
						</div>
					</div>
				}
				{ordered_parteien.map((partei, index) => (
					<div className="chart-parteien-group">
						{this.props.bezirksdaten.auszaehlung == 100
							?
								<>
									<div className="chart-parteien">
										<p className="partei">
											{partei.partei_key.startsWith('WGR ')
												? this.props.waehlergruppen[this.props.bezirksdaten.gebietsnummer][partei.partei_key]
												: this.props.parteien[partei.partei_key].Partei
											}
										</p>
										<div className="w100">
											<div className="bar rounded" style={{
												"width": partei.res_aktuell_proz ? (parseInt(partei.res_aktuell_proz) * 100 / max).toString() + "%" : "0",
												"background": this.props.parteien[partei.partei_key].Farbe
											}}></div>
											{this.props.preview !== true &&
												<div className="bar rounded" style={{
													"width": partei.res_old_proz ? (parseInt(partei.res_old_proz) * 100 / max).toString() + "%" : "0",
													"background": this.props.parteien[partei.partei_key].Farbe,
													"opacity": "0.3"
												}}></div>
											}
										</div>
										<div className="chart-parteien-percentage">
											<p>
												{this.props.showAbsolute
													? <NumberFormat value={partei.res_aktuell_total} decimalScale={0} fixedDecimalScale={true} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} />
													: <><NumberFormat value={partei.res_aktuell_proz} decimalScale={1} fixedDecimalScale={true} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /> %</>
												}
											</p>
											{this.props.preview !== true &&
												<p style={{"color": "#b4b4b4"}}>
													{partei.res_old_proz
														? (this.props.showAbsolute
															? <NumberFormat value={partei.res_old_total} decimalScale={0} fixedDecimalScale={true} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} />
															: <><NumberFormat value={partei.res_old_proz} decimalScale={1} fixedDecimalScale={true} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /> %</>)
														: "-"
													}
												</p>
											}
										</div>
									</div>
								</>
							:
								((index === 0 || this.props.preview) &&
									<>
										<div className="chart-parteien">
											<p>{index === 0 ? <i>Ergebnis liegt noch nicht vor.</i> : <span>&nbsp;</span>}</p>
											<div style={{"height": "1rem", "width": "1px"}}></div>
										</div>
									</>
								)
						}
					</div>
				))}
				{this.props.preview !== true && this.props.bezirksdaten.auszaehlung == 100 && 
					<div style={{display: "flex", "justify-content": "center"}}>
						<button className="link" onClick={this.changeShowAll} >
							{this.state.showAll
								? <><span>Weniger anzeigen</span><span className="turn-90deg" style={{"margin-left": "7px"}}>❯</span></>
								: <><span>Alle Parteien anzeigen</span><span className="turn90deg" style={{"margin-left": "7px"}}>❯</span></>
							}
						</button>
					</div>
				}
			</>
		)
	}
}